import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // 🎯 Added eye visibility icons
import axios from 'axios';
import Header1 from '../components/Header1';
import Footer from '../components/Footer';
import './Login.css'; // Import the CSS file for styling

const Login = () => {
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [showPassword, setShowPassword] = useState(false); // 🎯 Tracks eye toggle visibility
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    // Auto-redirect if token already exists
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                const currentTime = Date.now() / 1000; // Convert to seconds

                if (decoded.exp > currentTime) {
                    // Token is still alive! Direct entry allowed.
                    navigate('/cards');
                } else {
                    // Token expired -> wipe it
                    localStorage.removeItem('token');
                }
            } catch (error) {
                // Corrupted token string structure
                localStorage.removeItem('token');
            }
        }
    }, [navigate]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        if (error) setError(''); // Clear error text when user re-types
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // 💡 INDUSTRY CRITICAL: withCredentials tells axios to pass/receive cookies across domains
            const res = await axios.post(`${API_URL}/api/auth/login`, formData, {
                withCredentials: true 
            });

            // 1. Path A: Security Verification Challenge Prompted (Status 202)
            if (res.data.mfaRequired || res.status === 202) {
                if (res.data.verificationToken) {
                    sessionStorage.setItem('temp_verify_token', res.data.verificationToken);
                }
                // Redirect user to type in the email code sent via SendGrid
                navigate('/verify-code'); 
                return;
            }

            // 2. Path B: Direct login for recognized device footprint (Status 200)
            if (res.status === 200) {
                localStorage.setItem('token', res.data.token);
                navigate('/cards');
            }

        } catch (error) {
            console.error('Login routing trace rejection:', error);
            // Grabs custom backend message string layouts cleanly
            if (error.response && error.response.data && error.response.data.message) {
                setError(error.response.data.message);
            } else {
                setError('Invalid credentials or connection issue. Please try again.');
            }
        }
    };     

    return (
        <>
            <Header1 />
            <div className="login-container">
                <form onSubmit={handleSubmit}>
                    <h2>Login</h2>
                    {error && <div className="error-message">{error}</div>}
                    
                    <div className="input-group">
                        <input
                            type="email"
                            name="email"
                            placeholder="Email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* 🎯 CHANGED: Using a clean, unique container name specifically for this layout */}
                    <div className="password-input-group">
                        <input
                            type={showPassword ? 'text' : 'password'}
                            name="password"
                            placeholder="Password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                        />
                        <button 
                            type="button" 
                            className="password-toggle-btn"
                            onClick={() => setShowPassword(!showPassword)}
                            tabIndex="-1"
                        >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                    </div>

                    <button type="submit">Login</button>
                    <p>Don't have an account? <a href="/signup">Sign up</a></p>
                </form>
            </div>
            <Footer />
        </>
    );
};

export default Login;